<template>
  <div v-if="renderReady && !model.$disabled">
    <label v-if="getTitle" class="label">
      <w-next-number v-bind="nextNumber" v-if="nextNumber" />

      <template v-if="!setTitleAsPlaceholder">{{ getTitle }}</template>
      &nbsp;
      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{ tooltipContent }}</w-tooltip>
    </label>

    <w-description :model="model" v-bind="description">
      <slot name="description" />
    </w-description>

    <div
      class="input"
      :class="{'state-error': model.$error, 'state-disabled': disabled && !borderless}"
    >
      <component
        :is="prependicon && prependicon.startsWith('fa-') ? 'i' : 'span'"
        class="icon-prepend"
        v-if="prependicon || $slots.prependicon"
        :class="prependicon && prependicon.startsWith('fa-') ? prependicon + ' fa' : ''"
      >
        <slot
          name="prependicon"
          class="icon-prepend"
        >{{ prependicon.startsWith('fa-') ? '' : prependicon }}</slot>
      </component>

      <input
        :placeholder="getPlaceholder"
        ref="input"
        type="text"
        :class="['form-control', {borderless: borderless, 'text-right': textRight, 'has-append': appendicon || $slots.appendicon}, css]"
        :style="appendiconTextRight"
        :disabled="disabled"
        :readonly="model.$schema.readOnly"
        :value="svalue"
        @input="onInput($event)"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
        @mouseover="mouseOver($event)"
        @mouseleave="mouseOut($event)"
        :id="model.$form.generateId ? model.$pathId : undefined"
        :name="model.$form.testPath ? model.$path : undefined"
      />

      <component
        :is="appendicon && appendicon.startsWith('fa-') ? 'i' : 'span'"
        class="icon-append"
        v-if="appendicon || $slots.appendicon"
        :class="appendicon && appendicon.startsWith('fa-') ? appendicon + ' fa' : ''"
      >
        <slot
          name="appendicon"
          class="icon-append"
        >{{ appendicon.startsWith('fa-') ? '' : appendicon }}</slot>
      </component>
    </div>

    <div v-if="model.$schema.maxLength !== undefined" class="text-note text-muted">
      <small
        :class="{'text-danger': textLength > model.$schema.maxLength}"
      >{{ textLength }} z {{ model.$schema.maxLength || 0 }}</small>
    </div>

    <w-error v-if="showError" :model="model" @focus="$refs.input.focus()" />

    <w-warning
      v-if="showWarning && !(showError && model.$error)"
      :model="model"
      @focus="$refs.input.focus()"
    />
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';
import WWarning from './warning.vue';
import WTooltip from './tooltip.vue';

export default {
  name: 'w-input',
  components: {WError, WWarning, WTooltip},
  props: {
    placeholder: String,
    appendicon: {
      type: String,
      default: ''
    },
    prependicon: {
      type: String,
      default: ''
    },
    setTitleAsPlaceholder: {
      type: Boolean,
      default: false
    },
    showError: {
      type: Boolean,
      default: true
    },
    showWarning: {
      type: [Boolean, String],
      default: false
    },
    description: {
      type: Object,
      default: () => ({
        value: '',
        tooltip: false,
        htmlContent: false
      }),
      required: false
    },
    nextNumber: {
      type: Object,
      default: null,
      // default: () => ({
      //   level: null,
      //   value: null,
      //   type: null
      // }),
      required: false
    },
    css: [Object, String, Array]
  },
  mixins: [modelMixin],
  data() {
    return {
      placeHolder: ''
    };
  },
  computed: {
    textRight() {
      return this.model.$schema.type === 'number' || this.model.$schema.type === 'money' || this.model.$schema.type === 'integer';
    },
    appendiconTextRight() {
      return this.textRight && this.appendicon ? {paddingRight: '35px!important'} : {};
    },
    getPlaceholder() {
      this.placeHolder = this.placeholder;
      if (this.setTitleAsPlaceholder) {
        this.placeHolder = this.getTitle;
        return this.placeHolder;
      } else {
        return this.placeHolder;
      }
    },
    textLength() {
      if (!this.model.$model) {
        return 0;
      }

      return this.model.$model.length;
    }
  },
  methods: {}
};
</script>

<style>
.icon-prepend .checkbox,
.icon-append .checkbox {
  left: 1px !important;
  position: relative !important;
  top: -2px !important;
}
.smart-form .input input.has-append {
  padding-right: 37px !important;
}
.noborderdisabled td.input .icon-prepend label.checkbox,
.noborderdisabled td.input .icon-appendicon label.checkbox {
  margin-top: auto;
  margin-left: auto;
}
</style>
